import React from 'react';

import { getFormattedPrice } from '@tools/utils/common.tsx';

export interface PosCommissionSummaryProps {
  totalCommission: number;
  currency?: string;
}

export const PosCommissionSummary: React.FC<PosCommissionSummaryProps> = ({ totalCommission, currency }) => (
  totalCommission ? (
    <section className="pos-screen__commission" aria-label="Resumen de comisiones">
      <h2>Comisiones estimadas</h2>
      <p>Total comisiones: <strong>{getFormattedPrice(totalCommission, currency)}</strong></p>
    </section>
  ) : null
);

export default PosCommissionSummary;
